import { useMutation } from '@apollo/client';
import { CREATE_NOTIFICATION_MUTATION } from '../../mutations';

export function useCreateNotificationMutation() {
    return useMutation( CREATE_NOTIFICATION_MUTATION );
}
